import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useDispatch } from 'shared/hooks';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import ClassNames from 'classnames';
import { dispatchMapper, INIT } from '../../../shared/wizard/actions';
import WizardContainer from '../../../shared/legacy/WizardContainer';
import OutputContainer from 'shared/legacy/OutputContainer';
import { shapeInput } from '../config';
import Disclaimer from 'shared/legacy/Disclaimer';
import lazyWithRetry from "shared/utility/lazyWithRetry";

const wizardLandingPromise = import(
  /* webpackChunkName: "maandlasten-bij-aflossen-wizard-landing" */
  './WizardLanding'
);
const outputEmptyPromise = import(
  /* webpackChunkName: "maandlasten-bij-aflossen-output-empty" */
  './OutputEmpty'
);
const outputResultsPromise = import(
  /* webpackChunkName: "maandlasten-bij-aflossen-output-results" */
  './OutputResults'
);

const OutputResults = lazyWithRetry(() => outputResultsPromise);
const WizardLanding = lazyWithRetry(() => wizardLandingPromise);
const OutputEmpty = lazyWithRetry(() => outputEmptyPromise);

const App = ({ syncing, app, input, broken, framed, pages }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const base = `${app}${framed ? '/framed' : ''}`;

  useEffect(() => {
    dispatch({ type: INIT, payload: {} });
  }, []);

  useEffect(() => {
    navigate(`/${app}${framed ? '/framed' : ''}/${pages[0] + location.search}`, {
      state: { page: pages[0] },
      replace: true,
    });
  }, [framed]);

  if (input.show_disclaimer) {
    return (
      <div className="tool-container">
        <Disclaimer>
          <p>
            Ondanks de constante zorg en aandacht die wij besteden aan de samenstelling van deze tool en de daarin
            gevraagde gegevens,
            kunnen wij niet instaan voor de volledigheid, juistheid of voortdurende actualiteit van de gegevens.
            Wij aanvaarden dan ook geen aansprakelijkheid voor enigerlei directe of indirecte schade, van welke aard
            ook,
            die voortvloeit uit of in enig opzicht verband houdt met het gebruik van deze tool.
          </p>
          <p> Uw adviseur kan een exacte berekening voor u maken. </p>
        </Disclaimer>
      </div>
    );
  }

  return (
    <div
      className={ClassNames({
        'tool-container': true,
        busy: syncing,
        broken,
      })}
    >
      <WizardContainer forceStep={1} navigationDisabled>
        <Routes>
          <Route path={`${base}/*`} element={<WizardLanding /> } />
        </Routes>
      </WizardContainer>
      <OutputContainer navigationDisabled disclaimerDisabled>
        <Routes>
          <Route path={`${base}/final`}  element={<OutputResults /> } />
          <Route
            path={`${base}/landing`}
            element={<OutputEmpty text="Vul hiernaast uw gegevens in om een berekening te maken" />}
          />
        </Routes>
      </OutputContainer>
    </div>
  );
}

App.propTypes = {
  app: PropTypes.string.isRequired,
  broken: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
  framed: PropTypes.bool.isRequired,
  input: shapeInput.isRequired,
};

App.defaultProps = {};

export default connect(
  state => ({
    app: state.app,
    framed: state.framed,
    broken: state.broken,
    syncing: state.syncing,
    output: state.output,
    input: state.input,
    pages: state.pages,
    settings: state.settings,
  }),
  dispatchMapper,
)(App);
